"use client";

/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { openModal } from "action/modal/openModal";
import Accordion from "component/design-system/accordion/Accordion";
import PAButton, { BUTTON_TYPE } from "component/design-system/buttons/PAButton";
import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import Link from "next/link";
import { useDispatch } from "react-redux";
import { FbIcon } from "resources/svg-images/FbIcon";
import { InstaIcon } from "resources/svg-images/InstaIcon";
import { TwitterIcon } from "resources/svg-images/TwitterIcon";
import { YtIcon } from "resources/svg-images/YtIcon";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import useScreenSize from "hoc/useScreenSize";
import HorizontalSeparator from "component/design-system/horizontal-separator/HorizontalSeparator";
import LoaderSkeleton from "component/loader-skeleton/LoaderSkeleton";
import CustomerPaymentOptions from "./CustomerPaymentOptions";
import styles from "./footer.module.scss";
import footerLinks from "./footerLinks";

const ContactUsFooter = dynamic(() => import(/* webpackChunkName: "footer-contact-us" */ "./ContactUsFooter"), {
  loading: () => <LoaderSkeleton height={306} />,
});

const NewsletterFooter = dynamic(() => import(/* webpackChunkName: "news-letter-footer" */ "./newsletterFooter"));

function Footer() {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const [, , isDesktop] = useScreenSize();

  return (
    <div className={`hidden-print footer ${styles.footer_container}`}>
      {/* <div className="d-flex justify-content-center">
        <section className={`d-flex justify-content-center flex-wrap ${styles.container} ${styles.newsletterForm} `}>
          <NewsletterFooter />
        </section>
      </div> */}
      <div className={`d-flex justify-content-center ${styles.container_top}`}>
        <div className={`${styles.container} ${styles.footer_images}`}>

          <div className={`p-lr-10 ${styles.footer_images_child}`}>

            <PAText fontSize={FONT_SIZE[2]} className={`${styles.section_title}`}>{t("footer.trusted_shopping")}</PAText>

            <div className={styles.footer_flex}>

              <div className={styles.image_card}>
                <PAImage
                  src={getRelativeImagePath("/images/home/stripe.svg")}
                  alt="We use stripe payments"
                  title="We use stripe payments"
                  width={100}
                  height={55}
                />
              </div>
              <div className={styles.image_card}>
                <PAImage
                  src={getRelativeImagePath("/cms/pubicImages/images/SSL.webp")}
                  alt="We have ssl"
                  title="We have ssl"
                  width={100}
                  height={55}
                />
              </div>

              <div className={styles.image_card}>
                <PAImage
                  width={165}
                  height={55}
                  src={getRelativeImagePath("/cms/pubicImages/images/GoogleTopQualityStore.webp")}
                  alt="google store badge"
                  title="google store badge"
                />
              </div>

              <div className={styles.image_card}>
                <PAImage
                  src={getRelativeImagePath("/cms/pubicImages/images/Norton.webp")}
                  alt="We are norton secured"
                  title="We are norton secured"
                  width={165}
                  height={55}
                />

              </div>

            </div>
          </div>

          <div className={styles.payment_delivery_infos}>
            <HorizontalSeparator className="visible-xs visible-sm" />
            <div className={`${styles.footer_images_child} ${styles.payment_info}`}>
              <CustomerPaymentOptions />
            </div>
            <HorizontalSeparator className="visible-xs visible-sm" />
            <div className={`${styles.footer_images_child} ${styles.delivery_info}`}>
              <PAText fontSize={FONT_SIZE[2]} className={`${styles.section_title}`}>{t("footer.delivery_partners")}</PAText>

              <div className={styles.footer_flex}>

                <div className={styles.image_card}>
                  <PAImage
                    src={getRelativeImagePath("/images/home/fedex.svg")}
                    alt="We deliver via Fedex"
                    title="We deliver via Fedex"
                    width={118}
                    height={42}
                  />
                </div>

                <div className={styles.image_card}>
                  <PAImage
                    src={getRelativeImagePath("/images/home/canada-post.webp")}
                    alt="We deliver via Canada Post"
                    title="We deliver via Canada Post"
                    width={135}
                    height={42}
                  />
                </div>

                <div className={styles.image_card}>
                  <PAImage
                    src={getRelativeImagePath("/images/home/loomis.webp")}
                    alt="We deliver via Loomis"
                    title="We deliver via Loomis"
                    width={135}
                    height={42}
                  />
                </div>

                <div className={styles.image_card}>
                  <PAImage
                    src={getRelativeImagePath("/images/purolator.jpg")}
                    alt="We deliver via Purolator"
                    title="We deliver via Purolator"
                    width={135}
                    height={42}
                  />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      {/* <HorizontalSeparator className="m-b-0 m-t-0" /> */}
      <div className={`${styles.footer_maincontainer}`}>
        <div className={`${styles.newsletter_form_container} d-flex justify-content-center`}>
          <section className={`d-flex justify-content-center flex-wrap ${styles.container} ${styles.newsletterForm} `}>
            <NewsletterFooter />
          </section>
        </div>
        <div className={`d-flex justify-content-center m-b-0 ${styles.footer_subcontainer}`}>
          <div className={` ${styles.container} ${styles.footer_middle_container}`} style={{ border: "none" }}>

            <div className={styles.footer_middle_container_child}>

              <div className={`${styles.list_container}`}>
                <Accordion
                  titleClassName={styles.title_accordion}
                  className={styles.accordion}
                  contentClassNameContainer={styles.content_accordion_container}
                  contentClassName={styles.content_accordion}
                  isExpandable={!isDesktop}
                  isOpen={!!isDesktop}
                  title={(
                    <PAText bold fontSize={FONT_SIZE[2]}>
                      {t("footer.Help")}
                      {" "}
                      &amp;
                      {" "}
                      {t("footer.Support")}
                    </PAText>
                  )}
                  content={(
                    footerLinks.help.map((link) => (
                      <div key={link.href}>
                        <Link prefetch={false} href={link.href} title={link.title}>
                          {t(link.name)}
                        </Link>
                      </div>
                    ))
                  )}
                />
                <Accordion
                  titleClassName={styles.title_accordion}
                  className={styles.accordion}
                  contentClassNameContainer={styles.content_accordion_container}
                  contentClassName={styles.content_accordion}
                  title={(
                    <PAText bold fontSize={FONT_SIZE[2]}>{t("footer.Education")}</PAText>
                  )}
                  isExpandable={!isDesktop}
                  isOpen={!!isDesktop}
                  content={(
                    footerLinks.education.map((link) => (
                      <div key={link.name}>
                        <Link prefetch={false} href={link.href} title={link.title}>
                          {t(link.name)}
                        </Link>
                      </div>
                    ))
                  )}
                />
                <Accordion
                  titleClassName={styles.title_accordion}
                  className={styles.accordion}
                  contentClassNameContainer={styles.content_accordion_container}
                  contentClassName={styles.content_accordion}
                  isExpandable={!isDesktop}
                  isOpen={!!isDesktop}
                  title={(
                    <PAText bold fontSize={FONT_SIZE[2]}>
                      {t("footer.Accounts")}
                      {" "}
                      &amp;
                      {" "}
                      {t("footer.Orders")}
                    </PAText>
                  )}
                  content={(
                    <>
                      {footerLinks.accounts.map((link) => (
                        <div key={link.href}>
                          <Link prefetch={false} href={link.href} as={link.as} title={link.title}>
                            {t(link.name)}
                          </Link>
                        </div>
                      ))}
                      <div>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <PAButton
                          className={`btn ${styles.footer_btn}`}
                          buttonType={BUTTON_TYPE.NORMAL}
                          onClick={() => dispatch(openModal("feedback"))}
                        >
                          {t("footer.Report_Bug")}
                        </PAButton>
                      </div>
                      <div>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}

                        <PAButton
                          className={`btn ${styles.footer_btn}`}
                          buttonType={BUTTON_TYPE.NORMAL}
                          onClick={() => {
                            dispatch(openModal("signup"));
                          }}
                        >
                          {t("footer.Sign_Up")}
                        </PAButton>
                      </div>
                    </>
                  )}
                />
                <Accordion
                  className={styles.accordion}
                  titleClassName={styles.title_accordion}
                  contentClassNameContainer={styles.content_accordion_container}
                  contentClassName={styles.content_accordion}
                  isExpandable={!isDesktop}
                  isOpen={!!isDesktop}
                  title={(
                    <PAText bold fontSize={FONT_SIZE[2]}>
                      {" "}
                      {t("footer.Our_Services")}
                    </PAText>
                  )}
                  content={(
                    footerLinks.services.map((link) => (
                      <div key={link.href}>
                        <Link prefetch={false} href={link.href} title={link.title}>
                          {t(link.name)}
                        </Link>
                      </div>
                    ))
                  )}
                />
                <Accordion
                  titleClassName={styles.title_accordion}
                  className={styles.accordion}
                  contentClassNameContainer={styles.content_accordion_container}
                  contentClassName={styles.content_accordion}
                  isExpandable={!isDesktop}
                  isOpen={!!isDesktop}
                  title={(
                    <PAText fontSize={FONT_SIZE[2]} bold>
                      {" "}
                      {t("footer.About_Us")}
                    </PAText>
                  )}
                  content={(
                    <>
                      {footerLinks.about.map((link) => (
                        link.ariaLabel ? (
                          <div key={link.href}>
                            <a
                              aria-label={link.ariaLabel}
                              href={link.href}
                              title={link.title}
                            >
                              {t(link.name)}
                            </a>
                          </div>
                        ) : (
                          <div key={link.href}>
                            <Link prefetch={false} href={link.href} title={link.title}>
                              {t(link.name)}
                            </Link>
                          </div>
                        )
                      ))}
                      <div>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <PAButton
                          className={`btn ${styles.footer_btn}`}
                          buttonType={BUTTON_TYPE.NORMAL}
                          title="Tell us how you feel about PartsAvatar services"
                          onClick={() => dispatch(openModal("feedback"))}
                        >
                          {t("footer.Send_Feedback")}
                        </PAButton>
                      </div>
                    </>
                  )}
                />
              </div>

            </div>
          </div>
        </div>
      </div>

      <HorizontalSeparator className="m-t-0 hidden-xs hidden-sm" />

      <div className={`d-flex ${styles.footer_bottom} ${styles.container}`}>
        <div className={`${styles.section} ${styles.footer_bottom_section}`}>
          <PAText color="black" fontSize={FONT_SIZE[2]} className={styles.section_title}> FOLLOW US </PAText>
          <div className={styles.social_icons}>
            <a
              href="https://www.facebook.com/partsavatarcanada/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="facebook"
              title="Join PartsAvatar on Facebook for Updates and More"
            >
              <FbIcon />
            </a>

            <a
              href="https://twitter.com/PartsAvatar"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="twitter"
              title="Connect with PartsAvatar on Twitter for Updates and News"
            >
              <TwitterIcon />
            </a>

            <a
              href="https://www.instagram.com/partsavatarcanada/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="instagram"
              title="Follow PartsAvatar on Instagram for Visual Updates and Inspiration"
            >
              <InstaIcon />
            </a>

            <a
              href="https://www.youtube.com/channel/UCQNwNyuU7GR08xn-Ac13uoA"
              title="Explore PartsAvatar's YouTube Channel for Videos and Tutorials"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="youtube"
            >
              <YtIcon />
            </a>
          </div>
        </div>
        <HorizontalSeparator className="m-b-0 m-t-0 visible-xs visible-sm" />
        <div className={`${styles.section} ${styles.footer_bottom_section}`}>
          <PAText color="black" fontSize={FONT_SIZE[2]} className={styles.section_title}> Give Feedback </PAText>
          <PAButton
            buttonType={BUTTON_TYPE.OUTLINE}
            className={styles.feedback_button}
            onClick={(e) => {
              e.preventDefault();
              dispatch(openModal("feedbackModal", {
                onClose: () => { },
              }));
            }}
          >
            <i className="fa fa-comment-o" />
            Your Voice Matters
          </PAButton>
          <PAText color="grey-secondary" fontSize={FONT_SIZE[0]}> We'd love to learn more about your shopping experience and how we can improve! </PAText>

        </div>
        <HorizontalSeparator className="m-b-0 m-t-0 visible-xs visible-sm" />
        <div className={`d-flex flex-column ${styles.section} ${styles.contact_us} ${styles.footer_bottom_section}`}>
          <ContactUsFooter />
        </div>
      </div>
      <HorizontalSeparator className="m-b-0 m-t-0 visible-xs visible-sm" />
      <div className={`${styles.section} ${styles.footer_terms}`}>
        <Link
          href="/"
          prefetch={false}
          title="Welcome to PartsAvatar - Your Automotive Parts Destination"
          className={styles.copyright_link}
        >

          <i className="fa fa-copyright" />
          {" "}
          {`${new Date().getFullYear()} ${t("Parts Avatar Inc. All Rights Reserved")}`}
        </Link>
        <div className="d-flex justify-content-evenly p-b-10">
          <Link
            href="/autoparts-purchase-sale-terms"
            prefetch={false}
            title="Review and Understand Our Website's Terms and Conditions"
            className={styles.linkv2}
          >

            {t("footer.Terms_of_Use")}
            *
          </Link>
          {" "}
          <span className={`${styles.spacer}`}> •</span>
          <Link
            href="/online-privacy-shop-autoparts"
            prefetch={false}
            title="Get Informed About Our Privacy Practices"
            className={styles.linkv2}
          >
            {t("footer.Privacy_Policy")}
          </Link>
          {" "}
          <span className={`${styles.spacer}`}> •</span>
          <Link
            prefetch={false}
            href="/sitemap"
            title="Browse a Comprehensive Selection of Auto Components"
            className={styles.linkv2}
          >
            {t("footer.Sitemap")}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Footer;
